var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.948,
    height: 62.749,
    viewBox: "0 0 206.948 62.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 62.749,
    height: 206.948,
    fill: "#1e61ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(206.948) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M22.627,142.37a1.642,1.642,0,0,0,.668.917,2.487,2.487,0,0,0,2.615.888,3.58,3.58,0,0,0,2.461-2.43,2.174,2.174,0,0,0-.209-1.678,2.879,2.879,0,0,0-.466-1.286,2.081,2.081,0,0,0-2.75-.605c-1.6.225-2.776,2.54-2.319,4.193",
    transform: "translate(10.167 62.246)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M24.889,130.763a3.151,3.151,0,0,0,.367,1.81,1.733,1.733,0,0,0,.678.644,2.853,2.853,0,0,0,.9.21,1.859,1.859,0,0,0,2.234-1.344,1.89,1.89,0,0,0,.038-.343c1.071-1.215.775-3.763-1.119-3.832a1.977,1.977,0,0,0-1.586.724,2.462,2.462,0,0,0-1.511,2.129",
    transform: "translate(11.228 57.73)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M17.859,134.324a1.724,1.724,0,0,0,.192.694c-.02.122-.051.244-.06.366a1.057,1.057,0,0,0,.656,1.139,1.7,1.7,0,0,0,2.409.446,3.49,3.49,0,0,0,1.5-3.057,2.184,2.184,0,0,0-.932-2.03,1.858,1.858,0,0,0-1.938.122,2.056,2.056,0,0,0-1.829,2.321",
    transform: "translate(8.059 59.424)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M12.81,143.955a2.892,2.892,0,0,0,.833.161,2.359,2.359,0,0,0,2.006-.167,1.029,1.029,0,0,0,.835-1.226c.013-.017.028-.033.041-.054.817-1.309-.26-3.367-1.659-3.724a2.162,2.162,0,0,0-2.219.742,2.449,2.449,0,0,0-.925.547c-1.232,1.144-.276,3.222,1.089,3.721",
    transform: "translate(5.034 62.68)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M8.35,135.3a2.786,2.786,0,0,0,2.743.573,2.387,2.387,0,0,0,1.573-3.029,2.1,2.1,0,0,0-3.547-2.112,2.021,2.021,0,0,0-.435.624,3.839,3.839,0,0,0-.554.689A2.62,2.62,0,0,0,8.35,135.3",
    transform: "translate(3.461 58.723)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M17.739,125.325c.023.119.048.237.077.345a2,2,0,0,0,1.332,1.456,2.069,2.069,0,0,0,1.993-.832,3.087,3.087,0,0,0,.985-2.322,1.873,1.873,0,0,0-.987-1.4,1.827,1.827,0,0,0-.813-1.421,1.79,1.79,0,0,0-1.888.238,3.586,3.586,0,0,0-1.566,2.022,1.821,1.821,0,0,0,.866,1.914",
    transform: "translate(7.594 54.596)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M6.093,124.956a2.044,2.044,0,0,0,1.448.586,2.113,2.113,0,0,0,.742.254,1.776,1.776,0,0,0,.328.006,1.778,1.778,0,0,0,1-.138,2.669,2.669,0,0,0,.861-3.753,2.075,2.075,0,0,0-1.488-1.441c-.067-.022-.135-.039-.2-.057-.022,0-.039-.013-.061-.017H8.691a2.365,2.365,0,0,0-1.592.234,1.987,1.987,0,0,0-.7.617,4.4,4.4,0,0,0-.565.691,2.388,2.388,0,0,0,.255,3.02",
    transform: "translate(2.445 54.318)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M12.276,2.538,12.8,1.363S11.99,1,11.165.655L10.021.2,9.484,0,9.063,1.218l.5.184c.3.12.708.283,1.112.443.807.334,1.6.694,1.6.694",
    transform: "translate(4.09)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M15.476,4.189l.6-1.138s-.781-.422-1.579-.82-1.6-.787-1.6-.787l-.556,1.163s.794.37,1.572.774,1.556.808,1.556.808",
    transform: "translate(5.573 0.652)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M18.57,6.021l.672-1.1s-.759-.466-1.528-.913-1.544-.882-1.546-.882l-.627,1.125s.771.417,1.522.869,1.506.9,1.506.9",
    transform: "translate(7.014 1.411)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M21.553,8.03l.733-1.058s-.726-.514-1.47-1L19.326,5l-.692,1.087,1.469.959c.733.48,1.45.985,1.45.987",
    transform: "translate(8.41 2.255)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M24.416,10.2l.792-1.014L23.8,8.1l-1.44-1.049-.75,1.045,1.417,1.035L24.416,10.2",
    transform: "translate(9.754 3.181)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M27.148,12.533,28,11.566,26.656,10.4,25.28,9.269l-.811,1s.679.557,1.356,1.115l1.324,1.149",
    transform: "translate(11.044 4.183)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M29.733,15.022l.907-.914-1.271-1.247-1.306-1.209-.868.952,1.287,1.19,1.251,1.228",
    transform: "translate(12.274 5.259)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M32.164,17.663l.961-.858s-.578-.679-1.2-1.316L30.7,14.194l-.926.9s.6.636,1.2,1.274,1.181,1.3,1.181,1.3",
    transform: "translate(13.44 6.406)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M34.432,20.438l1.012-.8-1.125-1.379-.775-.948c-.212-.258-.363-.422-.363-.422l-.978.837s.148.161.357.415l.762.935c.556.678,1.11,1.357,1.11,1.357",
    transform: "translate(14.534 7.625)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M36.5,23.364l1.061-.73-1.016-1.461c-.52-.724-1.064-1.428-1.064-1.428l-1.029.775s.536.694,1.048,1.4,1,1.44,1,1.44",
    transform: "translate(15.549 8.911)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M38.385,26.408l1.107-.66s-.112-.192-.279-.482l-.655-1.033-.956-1.5-1.075.707s.469.739.94,1.479c.234.37.467.74.644,1.017l.273.475",
    transform: "translate(16.486 10.259)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M40.064,29.569l1.147-.588L40.384,27.4c-.2-.4-.414-.788-.588-1.074s-.279-.48-.279-.48l-1.119.636s.109.19.274.475.379.665.578,1.057l.813,1.553",
    transform: "translate(17.331 11.667)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M41.539,32.828l1.181-.512s-.084-.2-.213-.514l-.518-1.109-.755-1.612-1.158.563s.37.792.743,1.586c.184.4.37.794.509,1.091l.21.507",
    transform: "translate(18.088 13.125)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M42.79,36.179,44,35.744s-.3-.837-.605-1.675c-.142-.421-.332-.824-.454-1.135s-.212-.514-.212-.514l-1.193.486s.084.2.209.507.308.7.448,1.118c.3.824.6,1.649.6,1.649",
    transform: "translate(18.747 14.632)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M6,14.542l.679-1.094s-.639-.39-1.279-.784L4.1,11.9l-.626,1.126s.634.369,1.267.739L6,14.542",
    transform: "translate(1.567 5.372)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M8.529,16.223l.721-1.067L8.01,14.318l-1.258-.81-.7,1.084,1.245.8,1.228.83",
    transform: "translate(2.733 6.097)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M11,17.985l.756-1.042L9.321,15.207l-.733,1.059Z",
    transform: "translate(3.876 6.864)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M13.421,19.822l.79-1.017L11.825,17l-.768,1.033Z",
    transform: "translate(4.991 7.674)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M15.775,21.741l.823-.99-2.329-1.877-.8,1.009Z",
    transform: "translate(6.078 8.519)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M18.056,23.743l.858-.961-2.266-1.956-.835.981Z",
    transform: "translate(7.137 9.4)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M20.256,25.83l.894-.927-2.187-2.043-.871.949Z",
    transform: "translate(8.166 10.317)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M22.369,28l.932-.891-2.1-2.139-.906.916Z",
    transform: "translate(9.16 11.272)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M24.383,30.263l.968-.849-1.988-2.241-.943.878Z",
    transform: "translate(10.119 12.264)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M26.3,32.6l1.006-.8s-.463-.588-.93-1.176-.956-1.154-.956-1.154l-.981.835s.5.549.945,1.138L26.3,32.6",
    transform: "translate(11.028 13.302)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M28.091,35.03l1.049-.749s-.428-.615-.856-1.234c-.463-.588-.929-1.176-.929-1.176l-1.02.785.916,1.158.84,1.215",
    transform: "translate(11.886 14.385)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M29.759,37.543l1.09-.686-.239-.4c-.149-.238-.37-.543-.582-.852l-.853-1.235-1.062.729s.419.608.84,1.215c.208.3.425.6.572.839s.235.4.235.4",
    transform: "translate(12.688 15.51)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M31.249,40.16l1.131-.617-1.524-2.589-1.1.665Z",
    transform: "translate(13.428 16.679)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M32.518,42.884l1.173-.534-1.309-2.71-1.145.591Z",
    transform: "translate(14.098 17.891)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M3.033,41.87,3.75,40.8,2.223,39.79.671,38.8,0,39.9l1.521.969,1.512,1",
    transform: "translate(0 17.513)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M6.066,44.028l.755-1.044L5.332,41.92l-1.5-1.046L3.1,41.935,4.59,42.973c.737.528,1.476,1.055,1.476,1.055",
    transform: "translate(1.4 18.448)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M9.032,46.277l.787-1.02S9.09,44.7,8.363,44.149,6.9,43.056,6.9,43.056l-.763,1.036,1.454,1.086,1.446,1.1",
    transform: "translate(2.768 19.433)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M11.921,48.621l.817-1s-.7-.582-1.418-1.152-1.428-1.141-1.428-1.141l-.8,1.012s.714.56,1.419,1.132,1.408,1.145,1.408,1.145",
    transform: "translate(4.104 20.46)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M14.732,51.055l.852-.965s-.684-.61-1.382-1.2L12.812,47.7l-.829.985,1.38,1.178c.692.588,1.369,1.192,1.369,1.19",
    transform: "translate(5.408 21.529)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M17.456,53.585l.884-.935L17,51.4c-.671-.624-1.351-1.237-1.351-1.237l-.859.956s.671.607,1.334,1.225l1.329,1.237",
    transform: "translate(6.677 22.642)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M20.074,56.217l.925-.9s-.646-.649-1.29-1.3-1.3-1.286-1.3-1.286l-.9.924s.659.624,1.292,1.273l1.274,1.286",
    transform: "translate(7.902 23.801)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M22.57,58.966l.964-.856-1.225-1.363L21.056,55.41l-.936.885s.62.662,1.241,1.322l1.209,1.348",
    transform: "translate(9.081 25.009)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M24.92,61.828l1.006-.8s-.56-.727-1.152-1.427l-1.186-1.4-.977.84s.586.689,1.171,1.38,1.138,1.406,1.138,1.408",
    transform: "translate(10.205 26.268)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M27.1,64.815l1.054-.742s-.131-.189-.325-.473-.479-.644-.752-1.014l-1.094-1.472-1.022.785,1.08,1.451c.268.363.537.727.739,1l.321.466",
    transform: "translate(11.266 27.583)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M29.073,67.933l1.1-.665-.98-1.554c-.247-.388-.483-.781-.676-1.067s-.325-.472-.325-.472l-1.071.717s.129.187.319.466.424.666.668,1.048c.482.763.961,1.527.961,1.527",
    transform: "translate(12.243 28.965)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M30.765,71.2l1.155-.569-.833-1.641c-.2-.417-.443-.808-.61-1.109l-.284-.5-1.119.636.279.489c.164.3.4.681.6,1.087.406.8.816,1.607.816,1.607",
    transform: "translate(13.122 30.412)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M32.128,74.6l1.208-.448s-.315-.868-.66-1.724c-.372-.842-.745-1.684-.745-1.684l-1.174.533s.366.821.73,1.644c.337.833.641,1.679.641,1.679",
    transform: "translate(13.881 31.93)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M33.084,78.119l1.253-.3s-.054-.225-.132-.562a11.294,11.294,0,0,0-.332-1.225l-.54-1.768-1.223.4s.264.858.525,1.715a10.64,10.64,0,0,1,.322,1.19l.128.546",
    transform: "translate(14.492 33.518)",
    fill: "#1e61ad"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.bc31fc89a8512f65f9eb5c293a78afeb.svg";
export { ForwardRef as ReactComponent };